/* Ott-common */
import { AuthType } from '@dtvgo/axios-interceptor-auth';

export default function users(backendAxiosInstance) {
  function getUserProfile() {
    return backendAxiosInstance.get('/subscriber/v1/Users', {
      authType: AuthType.SESSION_TOKEN,
    });
  }

  /**
   * @typedef LoginFederatedParams
   * @type {object}
   * @property {string} accessToken
   * @property {string} provider
   * @property {string} deviceID
   */
  /**
   * @param {LoginFederatedParams} loginFederatedParams
   */
  function loginFederated(loginFederatedParams) {
    return backendAxiosInstance.post(
      '/subscriber/v1/Users/Login/Federated',
      loginFederatedParams,
    );
  }

  function renewToken() {
    return backendAxiosInstance.put('/subscriber/v1/Users/RenewToken',
      {},
      {
        authType: AuthType.SESSION_TOKEN,
        withoutRenew: true,
      });
  }

  function updateUser(profileWithModifications) {
    if (profileWithModifications) {
      return backendAxiosInstance.put('/subscriber/v1/Users/',
        profileWithModifications,
        {
          authType: AuthType.SESSION_TOKEN,
        });
    }
    return null;
  }

  return {
    getUserProfile,
    loginFederated,
    renewToken,
    updateUser,
  };
}
